<div [class]="'p-5 rounded-3xl shadow-1 ' + theme.current.newsletter">
    <app-text titleSize="text-2xl" [block]="block" [theme]="textTheme"></app-text>

    <div #scriptSection></div>
    <div *ngIf="block.add_reaction_time" class="flex gap-2.5 items-center justify-end">
        <div class="text-white">{{ 'REACTION_TIME' | translate }}</div>
        <img src="/assets/development/images/reaction_time.png" alt="Reaction Time" class="max-w-[108px]">
    </div>
</div>
